import '../../../internal-request/organisms/table/internal-request-table.css'
import InternalRequestStatusHint from 'domains/internal-request/components/internal-request-status-hint'
import OutboundInternalRequestsApiV2 from 'api/v2/admins/outbound-internal-requests-api-v2'
import { getInternalRequestListUrlState, syncInternalRequestListUrl } from 'domains/internal-request/services/internal-request-list-url-state'
import TitlePage from 'components/atoms/title-page'
import { useAuth } from 'providers/auth-provider'
import { REQUESTED_STATUS } from 'domains/internal-request/constants'
import InternalRequestTable from 'domains/internal-request/organisms/table'
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import {
  Alert, Button, Card,

  CardBody, CardHeader
} from 'reactstrap'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const InternalRequestRequestorListPage = ({ pageUtils }) => {
  const [ internalRequests, setInternalRequests ] = useState([])
  const [ pagination, setPagination ]             = useState({})
  const history                                   = useHistory()
  const location                                  = useLocation()
  const { user } = useAuth()
  const isReceiveSupervisor = [ 'owner', 'admin' ].includes(user?.role?.toString().trim().toLowerCase())
  const ownAwaitingReceive = new URLSearchParams(location.search).get('own_awaiting_receive') === '1'
  const awaitingReceive = new URLSearchParams(location.search).get('awaiting_receive') === '1' || ownAwaitingReceive
  const ownRequestName = String(user?.name || '').trim().replace(/\s+/g, ' ')
  const ownRequestParams = new URLSearchParams({ own_awaiting_receive: '1', status: REQUESTED_STATUS.DISPATCHED, request_by: ownRequestName })
  const initialUrlState                           = getInternalRequestListUrlState(location.search)
  const initialFilters                          = initialUrlState.filters.some((filter) => filter.id === 'status') ?
    initialUrlState.filters :
    [ ...initialUrlState.filters, { id: 'status', value: awaitingReceive ? [ REQUESTED_STATUS.DISPATCHED ] : [ REQUESTED_STATUS.DISPATCHED, REQUESTED_STATUS.REQUESTED ] } ]
  const [ isLoading, setIsLoading ]               = useState(true)

  const handleFetchInternalRequests = useCallback(async (tableState) => {
    syncInternalRequestListUrl({
      history,
      pathname      : window.location.pathname,
      currentSearch : window.location.search,
      tableState
    })

    setIsLoading(true)

    let additionalFilters = {}

    /**
     * We check whether user has been filtering by status columns.
     * if so, we don't need to use `additionalFilter`
     */
    const statusFilter = tableState.filters.find((filter) => filter.id === 'status')

    if (!statusFilter || statusFilter?.value?.length === 0) {
      additionalFilters = {
        status: [ REQUESTED_STATUS.DISPATCHED, REQUESTED_STATUS.REQUESTED ]
      }
    }

    if (awaitingReceive) additionalFilters = { ...additionalFilters, awaiting_receive: true }
    if (ownAwaitingReceive) additionalFilters = { ...additionalFilters, own_awaiting_receive: true, status: [ REQUESTED_STATUS.DISPATCHED ] }
    await OutboundInternalRequestsApiV2.index({ tableState, additionalFilters })
      .then((response) => {
        setInternalRequests(response.data.internal_requests)
        setPagination(response.data.meta)
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data)
      })
      .finally( () => setIsLoading(false) )
  }, [ history, pageUtils, awaitingReceive, ownAwaitingReceive ])

  /**
   * Handler to redirect to the particular pages
   * - If selected record status is requested, go to the detail page
   * - If selected record's status is dispatched, go to the receive page
   * @param {object} datum - selected row record
   */
  const handleSelectRow = useCallback((datum) => {
    const { id, status } = datum

    if (status === REQUESTED_STATUS.REQUESTED) {
      history.push({
        pathname: `new/${id}`
      })
    }
    else if (status === REQUESTED_STATUS.DISPATCHED) {
      history.push({
        pathname: `new/${id}/receive`
      })
    }
  }, [ history ])

  return (
    <>
      <TitlePage mainTitle='Internal Requests' subTitle='New List Page' />
      <Card>
        <CardHeader className='internal-request-actions'>
          <Button color='warning' outline tag='a' href={ `/app/internal-requests/requestor/new?${ownRequestParams.toString()}` }>Belum Diterima (Request saya)</Button>
          { isReceiveSupervisor && <Button color='warning' outline tag='a' href='/app/internal-requests/requestor/new?awaiting_receive=1&status=dispatched'>Belum Diterima (Semua Requestor)</Button> }
          <Button
            className='internal-request-create'
            color='primary'
            onClick={ () => {
              history.push({
                pathname: 'new/create'
              })
            } }
          >
            { 'Create New Request' }
          </Button>
        </CardHeader>
        <CardBody>
          { isReceiveSupervisor && <Alert color='info'>Owner/Admin: counter menampilkan seluruh request Dispatched yang belum diterima dari semua requestor. Gunakan Request By untuk mengingatkan pemohon. Receive All dapat dilakukan atas nama requestor setelah memastikan barang sudah diterima.</Alert> }
          <InternalRequestStatusHint audience='requestor' />
          <InternalRequestTable
            key={ awaitingReceive ? 'awaiting-receive' : 'new-requests' }
            categoryStatus={ REQUESTED_STATUS }
            data={ internalRequests }
            pagination={ pagination }
            isLoading={ isLoading }
            initialFilter={ initialFilters }
            initialPageIndex={ initialUrlState.pageIndex }
            initialPageSize={ initialUrlState.pageSize }
            onFetchData={ handleFetchInternalRequests }
            rowButtonProps={{
              buttonText    : 'View',
              buttonColour  : 'primary',
              onButtonClick : handleSelectRow
            }}
          />
        </CardBody>
      </Card>
    </>
  )
}

InternalRequestRequestorListPage.propTypes = propTypes

export default InternalRequestRequestorListPage
